import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import RouteKey from '../../../routes/key';
import {
  usePostCreateNewApplication
} from '../../../api-refactored/special-consideration/usePostCreateNewApplication';
import {
  useGetSelectedSpecialConsideration
} from '../../../api-refactored/special-consideration/useGetSelectedSpecialConsideration';
import InstructionsContent from './InstructionsContent';
import InstructionNotes from './InstructionNotes';
import { useWOGAA } from '../../../hooks/wogaa';

const {specialConsideration: specialConsiderationRoute} = RouteKey.child;
const {specialConsideration, selectSubject} = RouteKey['special-consideration'].child;

const SpecialConsiderationInstructions = () => {
  const history = useHistory<any>();
  const examLevelUuid = history.location.state?.examLevelUuid;
  const examSeriesUuid = history.location.state?.examSeriesUuid;
  const applicationUuid = history.location.state?.applicationUuid;
  const isContinueApplication = history.location.state?.isContinueApplication;
  const [validationMsg, setValidationMsg] = useState<string>('');

  const {
    mutate: mutatePostCreateNewApplication,
    status: newApplicationStatus,
  } = usePostCreateNewApplication({
    onSuccess: ({uuid}) => {
      if (uuid) {
        history.push(
            `/${specialConsiderationRoute}/${specialConsideration.route}/${uuid}/${selectSubject.route}`
        );
      }
    },
    onError: ({response}) => {
      if (response) {
        setValidationMsg(response.data.message!);
      }
    },
  });

  const {data: selectedCandidateData} = useGetSelectedSpecialConsideration({
    uuid: applicationUuid || '',
    enabled: isContinueApplication,
  });
// Wogaa tracking start for SC application by candidate
  const { transactionStart } = useWOGAA('myexamsseab-6461');

  const continueApplication = () => {
      transactionStart();
      history.push(
          `/${specialConsiderationRoute}/${specialConsideration.route}/${selectedCandidateData?.uuid}/${selectSubject.route}`
      );
  };

  const startApplication = () => {
    if (examLevelUuid && examSeriesUuid) {
      transactionStart();
      mutatePostCreateNewApplication({
        examLevelUuid,
        examSeriesUuid,
      });
    }
  };

  // Should not allow user to access instruction page when they directly enter url in browser
  if (isContinueApplication === undefined) {
    history.push(`/${specialConsiderationRoute}/${specialConsideration.route}`);
    return <></>;
  }

  return (
      <InstructionsContent
          isContinueApplication={isContinueApplication}
          applicationId={selectedCandidateData?.applicationId}
          examLevel={selectedCandidateData?.examLevel}
          continueApplication={continueApplication}
          startApplicationStatus={newApplicationStatus}
          startApplication={startApplication}
          validationMsg={validationMsg}
          instructionNotes={<InstructionNotes/>}
      />
  );
};

export default SpecialConsiderationInstructions;
